/**
 * エラーメッセージの配列の最初の要素を取得します。
 * Retrieves the first element of an error message array.
 *
 * @example
 * const errors = ['Name is required', 'Name must be unique'];
 * const firstError = firstError(errors); // 'Name is required'
 *
 * const emptyErrors: string[] = [];
 * const firstEmptyError = firstError(emptyErrors); // ''
 *
 * const undefinedErrors: string[] | undefined = undefined;
 * const firstUndefinedError = firstError(undefinedErrors); // ''
 */
export const firstError = (errors: string[] | undefined): string => {
  if (!Array.isArray(errors)) {
    return '';
  }
  return errors.length > 0 ? errors[0] : '';
};

/**
 * エラーメッセージの配列にエラーが存在するかどうかをチェックします。
 * Checks if there is any error in the error message array.
 *
 * @example
 * const errors = ['Name is required', 'Name must be unique'];
 * const hasErrors = hasError(errors); // true
 *
 * const emptyErrors: string[] = [];
 * const hasNoErrors = hasError(emptyErrors); // false
 *
 * const undefinedErrors: string[] | undefined = undefined;
 * const hasNoUndefinedErrors = hasError(undefinedErrors); // false
 */
export const hasError = (errors: string[] | undefined): boolean => {
  return Array.isArray(errors) && errors.length > 0;
};
